var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwaPopup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.358,
    height: 76.158,
    viewBox: "0 0 52.358 76.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1953",
    "data-name": "Group 1953",
    transform: "translate(-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M54.978,52.358a2.38,2.38,0,0,0,2.38-2.38V11.9A11.9,11.9,0,0,0,45.459,0H16.9A11.9,11.9,0,0,0,5,11.9V64.258a11.9,11.9,0,0,0,11.9,11.9H45.459a11.9,11.9,0,0,0,11.9-11.9V59.5a2.38,2.38,0,0,0-4.76,0v4.76a7.14,7.14,0,0,1-7.14,7.14H16.9a7.14,7.14,0,0,1-7.14-7.14V11.9a7.14,7.14,0,0,1,4.76-6.711v1.5a7.592,7.592,0,0,0,7.592,7.592H40.247a7.592,7.592,0,0,0,7.592-7.592v-1.5A7.14,7.14,0,0,1,52.6,11.9V49.978A2.38,2.38,0,0,0,54.978,52.358ZM43.079,6.688A2.832,2.832,0,0,1,40.247,9.52H22.112A2.832,2.832,0,0,1,19.28,6.688V4.76h23.8Z",
    fill: "#1eb858"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1952",
    "data-name": "Group 1952",
    transform: "translate(16.9 21.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M36.179,18a2.38,2.38,0,0,0-2.38,2.38v2.38a2.38,2.38,0,0,1-2.38,2.38H17.14a2.38,2.38,0,0,1-2.38-2.38V20.38a2.38,2.38,0,1,0-4.76,0v2.38a7.14,7.14,0,0,0,7.14,7.14h14.28a7.14,7.14,0,0,0,7.14-7.14V20.38A2.38,2.38,0,0,0,36.179,18Z",
    transform: "translate(-10 3.419)",
    fill: "#1eb858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M19.836,32.109a2.38,2.38,0,0,0,3.379,0l7.14-7.14a2.39,2.39,0,1,0-3.379-3.379l-3.07,3.094V11.38a2.38,2.38,0,1,0-4.76,0v13.3l-3.07-3.094A2.39,2.39,0,0,0,12.7,24.969Z",
    transform: "translate(-7.246 -9)",
    fill: "#1eb858"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwaPopup);
export default __webpack_public_path__ + "static/media/pwa-popup.9327ebe2ce408a4a3f3b5d9c6c05683a.svg";
export { ForwardRef as ReactComponent };